import * as React from "react";
import { Device, StudyScheduleSession } from "webportalclient";
import { Subject } from "../../../misc/api/apiTypes";
import { useWebPortalApiClient } from "../../../misc/api/WebPortalTokenClient";
import LoadingWithMessage from "../../../misc/components/LoadingWithMessage";
import { ConfigureDiaryDeployments } from "../P230In2itiveEDiary/ConfigurationHelpers";
import { ConfigureP230HomeSpirometrySession } from "./P230HomeSpirometryConfiguration";

interface P230HomeSpirometryRemoteConfigureProps {
    subject: Subject;
    remoteDeviceSelected: Device;
    sessionScheduleItems: StudyScheduleSession[];
    onComplete: (redirect?: string) => void;
}

export const P230HomeSpirometryRemoteConfigure = ({ subject, remoteDeviceSelected, sessionScheduleItems, onComplete }: P230HomeSpirometryRemoteConfigureProps) => {
    const client = useWebPortalApiClient();

    React.useEffect(() => {
        const remoteConfigure = async () => {
            await ConfigureDiaryDeployments(client.client, subject.Id, sessionScheduleItems, remoteDeviceSelected.serialNumber);

            const analysisSetResult = await ConfigureP230HomeSpirometrySession(client.client, remoteDeviceSelected.serialNumber, subject, sessionScheduleItems[0], true);

            onComplete(`/spirometry/siteAnalysis/${analysisSetResult.id}/edit`);
        }

        remoteConfigure();
    }, []);

    return (
        <div className="modal-body">
            <LoadingWithMessage message="Starting Home Spirometry session..." />
        </div>
    );
}
